// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_nz-0";